// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3RLnK","bigColWidth":"Table_bigColWidth__56CLZ","biggerColWidth":"Table_biggerColWidth__QvtjR","row":"Table_row__3QhsV","col":"Table_col__36a9J"};